import dayjs from 'dayjs'
import type { ZodString } from 'zod'
import { z } from 'zod'

// TODO: Has been added to zod natively but this would require to update the zod patch
// https://zod.dev/?id=dates
export const date = (type: ZodString = z.coerce.string()) => {
  return z.preprocess(
    val => (val ? dayjs(val as Date).format('YYYY-MM-DD') : val),
    type.regex ? type.regex(/^\d{4}-\d{2}-\d{2}$/).nullish() : type,
  )
}

export const time = (type: ZodString = z.coerce.string()) => {
  return z.preprocess(
    val => (val ? dayjs(val as Date).format('HH:mm') : val), //
    type,
    // type.regex ? type.regex(/^\d{2}:\d{2}$/).nullish() : type,
  )
}

export const number = () => {
  return z.union([z.string(), z.number()]).pipe(z.coerce.string()).default('')
}

export const boolean = () => {
  return (
    z
      // Utility to workaround sqlite having 0 and 1 as boolean values
      .union([z.string(), z.boolean(), z.number()])
      .pipe(z.coerce.string())
      .transform(v => {
        if (v === 'false' || v === '' || v === '0') {
          return false
        }
        if (v === 'true' || v === '1') {
          return true
        }
        if (v === null || v === 'null') {
          return null
        }
        return undefined
      })
      .default('')
  )
}

const f = {
  boolean,
  date,
  time,
  number,
}

export default f
